export class SuspensionSettings {
  weightDistributionPercent: number;
  lowSpeedStability: number;
  highSpeedStability: number;
  rotationalG1: number;
  rotationalG2: number;
  rotationalG3: number;
  rideHeightFront: number;
  rideHeightRear: number;
  downforceFront: number;
  downforceRear: number;
  calculateRearDownforce: boolean = false;
  springStiffness: number = 0;
  arbStiffness: number = 0;
  tireWear: number = 1;
  oversteerUndersteer: number = 0;
  reduceCornerEntryUndersteerOversteer: number = 0;
  reduceCornerExitUndersteerOversteer: number = 0;
  offsetSpringFrequency: number = 0;
}

